exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-background-3MZsB{background-color:#fff;width:100%;height:100%}.style-cssmodule-container-2JiPf{--max-width:1800px;container-type:inline-size;padding:var(--global-padding);max-width:var(--max-width);width:100%;margin:0 auto;gap:20px;display:flex;flex-direction:column}.style-cssmodule-card-2qC-O{box-shadow:var(--card-shadow)}.style-cssmodule-container-2JiPf header{display:block}.style-cssmodule-title-3lBvQ{color:var(--color-night-gray9,#2c3652);font-family:Roboto;font-size:24px;font-style:normal;font-weight:400;line-height:36px}", ""]);

// exports
exports.locals = {
	"background": "style-cssmodule-background-3MZsB",
	"container": "style-cssmodule-container-2JiPf",
	"card": "style-cssmodule-card-2qC-O",
	"title": "style-cssmodule-title-3lBvQ"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/style.cssmodule.css
// module id = 2567
// module chunks = 121